<template>
  <BaseLayout pageTitle="消息">
    <template v-slot:actions-end>
      <div></div>
    </template>
    <div class="news">
      <ListItem
        v-for="(item, index) in newsData"
        :key="index"
        :readed="item.readed"
        :name="item.name"
        :title="item.cardTitle"
        :lawyerName="item.dutyLawyerUserName"
        :time="item.logCreateTime || item.cardCreateTime"
        :content="item.logDetails"
        :avatar="item.dutyLawyerUserImgUrl"
        :fileList="item.fileShowList"
        :tblId="item.tblId"
        :processNodeTblId="item.processNodeTblId"
      />
    </div>
    <div v-if="!newsData">
      <ion-list>
        <ion-item>
          <ion-thumbnail slot="start">
            <ion-skeleton-text animated></ion-skeleton-text>
          </ion-thumbnail>
          <ion-label>
            <h3>
              <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
            </p>
            <p>
              <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
      <ion-list>
        <ion-item>
          <ion-thumbnail slot="start">
            <ion-skeleton-text animated></ion-skeleton-text>
          </ion-thumbnail>
          <ion-label>
            <h3>
              <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
            </p>
            <p>
              <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
      <ion-list>
        <ion-item>
          <ion-thumbnail slot="start">
            <ion-skeleton-text animated></ion-skeleton-text>
          </ion-thumbnail>
          <ion-label>
            <h3>
              <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
            </p>
            <p>
              <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>

    <!-- <NativeTabNavigatoLayout /> -->
  </BaseLayout>
</template>

<script>
import { delay, newsApi } from '@/apis/index.js'
import { ref, onBeforeMount, onMounted, computed } from 'vue'
import { ListItem } from '@/view/news/components'
import { useStore } from 'vuex'

export default {
  setup(props, { emit }) {
    const store = new useStore()
    // const newsData = ref([])

    // const getData = async (content) => {
    //   const data = await newsApi.list()
    //   newsData.value = data.list
    // }

    const newsData = computed(() => store.getters['news/data'])
    // 页面渲染事件
    onBeforeMount(async () => {
      // getData()
      store.dispatch('news/runTimer')
    })
    return { newsData }
  },
  components: { ListItem },
}
</script>